// @ts-nocheck — generated Thrift JS uses CommonJS patterns
import { Buffer } from 'buffer';
globalThis.Buffer = globalThis.Buffer || Buffer;

import thrift from 'thrift';
import * as WandService from '@helinks/wand-api-thrift/WandService';
import { log } from '$lib/log';
import { installReliableXhrTransport } from './thriftConnection';

// Same-origin /api in both dev and prod:
// - dev: Vite proxies /api → http://127.0.0.1:18080 (see vite.config.ts)
// - prod: Traefik routes wand.infra.helinks.com/api → backend container :8080
const isBrowser = typeof window !== 'undefined';
const host = isBrowser ? window.location.hostname : 'localhost';
const port = isBrowser
  ? Number(window.location.port) || (window.location.protocol === 'https:' ? 443 : 80)
  : 5173;
const https = isBrowser && window.location.protocol === 'https:';

const connection = installReliableXhrTransport(thrift.createXHRConnection(host, port, {
  transport: thrift.TBufferedTransport,
  protocol: thrift.TJSONProtocol,
  path: '/api',
  https,
}));

connection.on('error', (err: Error) => {
  log.error('Thrift connection error:', err);
});

const client = thrift.createXHRClient(WandService, connection);

export default client;
export { connection, WandService };
